import { Box, Grid, styled, Typography } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  heading?: string
  height?: string
  paddingX?: number
  paddingY?: number
  showHeading?: boolean
  containerSx?: SxProps;
  fillHeight?: boolean;
}

const StyledTabHeading = styled(Typography)({
  padding: 8,
  paddingLeft: 16,
  borderBottom: '1px solid #ccc',
  borderColor: "divider"
})

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, heading, height = "calc(100vh - 50px)", paddingX, paddingY, showHeading = true, containerSx, fillHeight = false }) => {
  if (value !== index) return;

  return (
    <Box sx={{ position: "relative", textAlign: "initial", ...(fillHeight && { height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }), ...containerSx }}>
      {heading && showHeading && <StyledTabHeading align="left" variant="h6" sx={fillHeight ? { flexShrink: 0 } : undefined}> {heading} </StyledTabHeading>}
      <Grid
        container
        height={fillHeight ? undefined : height}
        alignContent='flex-start'
        paddingX={paddingX}
        paddingY={paddingY}
        sx={fillHeight ? { flex: 1, minHeight: 0, flexDirection: "column", flexWrap: "nowrap", overflow: "hidden" } : { overflowY: 'scroll' }}
        size={12}>
        {children}
      </Grid>
    </Box>
  );
}

export default TabPanel;
